define([
	"dojo/_base/declare",
	"csi/table/Copy"
], function(declare,Copy) {

	return declare(Copy, {
		onCreatePopup: function(/*csi.view.Widget*/view) {
			// summary: set default value for request level
			view.addFixedValue("SampleStorage", this.getNode().SampleStorage);
			this.inherited(arguments);
		}
	});
});